import intl from "react-intl-universal";
import { TbAlertTriangle, TbX } from "react-icons/tb";
import { useHistory } from "react-router-dom";

export const BaasHomeAlerts = ({
  pendingKybCount = 0,
  pendingCount = 0,
  apiErrorCount = 0,
  webhookFailureCount = 0,
  dismissed,
  onDismiss,
}) => {
  const history = useHistory();

  if (dismissed) {
    return null;
  }

  const hasPendingKyb = pendingKybCount > 0;
  const hasPending = pendingCount > 0;
  const hasWebhookAlert = webhookFailureCount > 0;
  const hasApiAlert = apiErrorCount > 0;

  if (!hasPendingKyb && !hasPending && !hasWebhookAlert && !hasApiAlert) {
    return null;
  }

  const severity = hasWebhookAlert || hasApiAlert ? "warning" : "info";
  const containerClass =
    severity === "warning"
      ? "border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900/50 dark:bg-amber-950/30 dark:text-amber-200"
      : "border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-900/50 dark:bg-blue-950/30 dark:text-blue-200";

  const messages = [];

  if (hasPendingKyb) {
    messages.push(
      intl.get("baas.entidades.alert.pendingKyb", { count: pendingKybCount }),
    );
  }

  if (hasPending) {
    messages.push(intl.get("baas.entidades.alert.pendingReview", { count: pendingCount }));
  }

  if (hasWebhookAlert) {
    messages.push(
      intl.get("baas.home.dashboard.alerts.webhookFailure", {
        count: webhookFailureCount,
      }),
    );
  }

  if (hasApiAlert) {
    messages.push(
      intl.get("baas.home.dashboard.alerts.apiErrors", { count: apiErrorCount }),
    );
  }

  const navigateToEntidades = (presetFilters) => {
    history.push({
      pathname: "/baas/entidades",
      state: { presetFilters },
    });
  };

  return (
    <div
      className={`flex flex-col gap-3 rounded-xl border px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${containerClass}`}
      role="status"
    >
      <div className="flex min-w-0 items-start gap-3">
        <TbAlertTriangle className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
        <div className="min-w-0 space-y-1">
          <p className="text-sm font-semibold">{intl.get("baas.home.dashboard.alerts.title")}</p>
          {messages.map((message) => (
            <p key={message} className="text-sm opacity-90">
              {message}
            </p>
          ))}
        </div>
      </div>

      <div className="flex shrink-0 flex-wrap items-center gap-2">
        {hasPendingKyb ? (
          <button
            type="button"
            className="extract-filter-panel__btn extract-filter-panel__btn--primary !h-8 !px-3 !text-xs"
            onClick={() =>
              navigateToEntidades({ kybStatuses: ["pending", "in_review"] })
            }
          >
            {intl.get("baas.entidades.alert.viewPendingKyb")}
          </button>
        ) : null}
        {hasPending ? (
          <button
            type="button"
            className="extract-filter-panel__btn !h-8 !px-3 !text-xs"
            onClick={() => navigateToEntidades({ statuses: ["pending"] })}
          >
            {intl.get("baas.entidades.alert.viewPending")}
          </button>
        ) : null}
        {hasWebhookAlert || hasApiAlert ? (
          <button
            type="button"
            className="extract-filter-panel__btn !h-8 !px-3 !text-xs"
            onClick={() => history.push("/baas/api")}
          >
            {intl.get("baas.home.dashboard.alerts.viewApi")}
          </button>
        ) : null}
        <button
          type="button"
          className="inline-flex h-8 w-8 items-center justify-center rounded-lg transition hover:bg-black/5 dark:hover:bg-white/10"
          onClick={onDismiss}
          aria-label={intl.get("words.close")}
        >
          <TbX size={16} aria-hidden />
        </button>
      </div>
    </div>
  );
};
